import { jsx as _jsx } from "react/jsx-runtime";
import IcomoonReact from "icomoon-react";
import { IconSizes, noColors } from "./constants";
import { getIconColor } from "./Icon.style";
import iconSet from "./selection.json";
const Icon = ({ name = "", size = "small", className = "", onClick = () => { }, ...props }) => {
    const color = getIconColor(props);
    const isEnum = (size) => {
        return Object.values(IconSizes).includes(size);
    };
    return (_jsx(IcomoonReact, { className: className, icon: name, size: isEnum(size) ? size : IconSizes[size], color: noColors.includes(name) ? undefined : color, iconSet: iconSet, role: "img", onClick: onClick, children: _jsx("span", { "aria-hidden": true, children: name }) }));
};
export default Icon;
//# sourceMappingURL=Icon.js.map